import { useState, useEffect } from 'react';

interface EmailVerificationState {
  showUnverifiedBanner: boolean;
  showSuccessBanner: boolean;
  dismissUnverifiedBanner: () => void;
}

const BANNER_DISMISSED_KEY = 'email-verification-banner-dismissed';

export function useEmailVerificationState(
  isEmailVerified: boolean,
  authProvider: string
): EmailVerificationState {
  const [bannerDismissed, setBannerDismissed] = useState(false);

  // Check if banner was previously dismissed
  useEffect(() => {
    const dismissed = localStorage.getItem(BANNER_DISMISSED_KEY);
    setBannerDismissed(dismissed === 'true');
  }, []);

  // Determine when to show unverified banner
  const showUnverifiedBanner = 
    !isEmailVerified && 
    authProvider === 'email' && 
    !bannerDismissed;

  // Show success banner when verified (handled by EmailVerificationSuccessBanner component)
  const showSuccessBanner = isEmailVerified;

  const dismissUnverifiedBanner = () => {
    setBannerDismissed(true);
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
  };

  // Clear dismissed state when email becomes verified (for future use)
  useEffect(() => {
    if (isEmailVerified && bannerDismissed) {
      localStorage.removeItem(BANNER_DISMISSED_KEY);
      setBannerDismissed(false);
    }
  }, [isEmailVerified, bannerDismissed]);

  return {
    showUnverifiedBanner,
    showSuccessBanner,
    dismissUnverifiedBanner,
  };
}